// extracted by mini-css-extract-plugin
export default {"frame-information":"frame-information_frame-information__gaksa","image":"frame-information_image__HDk4-","image-container":"frame-information_image-container__L6f5n"};